module.exports = __webpack_public_path__ + "static/assets/mywellfie-header-logo.png";